import { render, staticRenderFns } from "./addAndonRule.vue?vue&type=template&id=47465f54&scoped=true&"
import script from "./addAndonRule.vue?vue&type=script&lang=js&"
export * from "./addAndonRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47465f54",
  null
  
)

export default component.exports